<template>
  <fragment>
    <c-partners-hero class="illustration-section-01" />
    <c-partners-tiles class="illustration-section-02" />
  </fragment>
</template>

<script>
import CLayout from '@/layouts/LayoutDefault.vue';
import CPartnersHero from '@/components/sections/PartnersHero.vue';
import CPartnersTiles from '@/components/sections/PartnersTiles.vue';

export default {
  name: 'Partners',
  components: {
    CPartnersHero,
    CPartnersTiles
  },
  async created() {
    this.$emit('update:layout', CLayout);
  }
};
</script>
